export enum TradeState {
  WaitingForBuyerSignature = 1,
  SignedByBuyer,
  RejectedByBuyer,
  RejectedBySeller,
}
